import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

/**
 * @typedef {import("../AdjustmentReasonCode.typedef.mjs").AdjustmentReasonCodeComponentProps} useAdjustmentReasonCodeParam
 * @param {useAdjustmentReasonCodeParam} props
 * @returns
 */
const useAdjustmentReasonCode = ({
  onSelect,
  selectMode,
  hideModal,
  params: initialSelectParams,
  lookupType,
}) => {
  const { axios_helper_no_header } = useAxios();

  /**
   * @type {AdjustmentReasonCode[]}
   */
  const initialData = [];
  /**
   * @typedef {import("../AdjustmentReasonCode.typedef.mjs").AdjustmentReasonCode} AdjustmentReasonCode
   * @type {[AdjustmentReasonCode[], React.Dispatch<React.SetStateAction<AdjustmentReasonCode[]>>]}
   */
  const [data, setData] = useState(initialData);

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const toast = useToast();
  const location = useLocation();
  const {
    ADJUSTMENT_REASON_CODE_ADD,
    ADJUSTMENT_REASON_CODE_EDIT,
    ADJUSTMENT_REASON_CODE_DISPLAY,
  } = ROUTE_PATHS;
  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);

  const {
    selectedAdjustmentReason = [],
    selectedCodesListItem = "",
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      adjAdjustmentCode: "",
      hiddenRecordIndicator: "Active",
    },
  } = currentState;
  const [paramsData, setParamsData] = useState(initialParamsData);

  const screen_title = "Adjustment Reason Code";
  const screenNumber = selectMode ? "RCADJ002" : "RCADJ001";
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]?.adjAdjustmentCode;
  const updatedParamsData = {
    ...paramsData,
    adjAdjustmentCode: lastScheduleName,
  };

  const formFields = [
    {
      fieldLabel: "ADJ Adjustment Code",
      name: "adjAdjustmentCode",
      label: "Code",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const ctaButtons = selectMode
    ? []
    : [
        {
          button_label: "Add Adjustment Reason Code",
          button_handeler: () => {
            navigateToPage(ADJUSTMENT_REASON_CODE_ADD, [
              {
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  const handleBack = () => {
    if (selectMode && hideModal) {
      hideModal();
    } else if (currentIndex < selectedAdjustmentReason.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  const menuOptions = selectMode
    ? [
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            const paramData = selectParams.reduce((acc, key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                acc[key["source"]] = rowData[key["target"]];
              }
              return acc;
            }, {});
            if (lookupType === "local") {
              console.log(
                "paramData",
                paramData,
                "selectParams",
                selectParams,
                "rowData",
                rowData
              );
              onSelect(paramData);
            } else {
              const message = {
                type: "responseData",
                data: paramData,
              };
              window.parent.postMessage(message, "*");
            }
            // addAdjustmentReasonCodes();
          },
        },
      ]
    : [
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            navigateToPage(ADJUSTMENT_REASON_CODE_EDIT, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedAdjustmentReason: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            navigateToPage(ADJUSTMENT_REASON_CODE_DISPLAY, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedAdjustmentReason: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
      ];

  const columnDef = [
    {
      header: "Code",
      field: "adjAdjustmentCode",
    },
    {
      header: "Description",
      field: "adjAdjustmentDesc",
    },
  ];

  const parmKey = "adjAdjustmentCode";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/adjAdjustmentReason`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteAdjustmentReasonCode = () => {
    if (selectedOption === "yes") {
      const params = { adjAdjustmentCode: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/adjAdjustmentReason", null, params)
        .then((response) => {
          const updatedItems = data.filter(
            (item) => item.adjAdjustmentCode !== rowData.adjAdjustmentCode
          );
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;

          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/adjAdjustmentReason/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteAdjustmentReasonCode,
    setSelectedOption,
    selectMode,
  };
};

export default useAdjustmentReasonCode;
